import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DataMappingService } from '../../services/data-mapping.service';
import { JsonDataService } from '../../services/json-data.service';
import { PetService } from '../../services/pet.service'
import { PickUpDetail } from '../../interfaces/pick-up';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { convertToLocalTimeToUTC } from '../../utils/date-util';

@Component({
  selector: 'app-pick-up-detail',
  templateUrl: './pick-up-detail.component.html',
  styleUrls: ['./pick-up-detail.component.scss']
})
export class PickUpDetailComponent implements OnInit {
  selectedPickUp: any;
  public pickUpDetailForm: FormGroup;
  isLoading = false;
  isNew = false;
  pickUpUpdateData = new FormData();
  isSavingPickUp = false;
  public onClose= new Subject<boolean>();

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {
    this.pickUpDetailForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      phone: '',
      address: '',
      date: '',
      time: ''
    });
  }

  ngOnInit(): void {
    console.log(`PickUpDetailComponent, ngOnInit, This is pick up detail modal`);
    console.log(`PickUpDetailComponent, ngOnInit, isNew: ${this.isNew}`);
    if (!this.isNew) {
      console.log(`PickUpDetailComponent, selectedPickUp: ${JSON.stringify(this.selectedPickUp)}`);
      this.patchPickUpDetailForm(this.selectedPickUp);
    }
  }

  patchPickUpDetailForm(pickUp: PickUpDetail) {
    this.pickUpDetailForm.patchValue(pickUp);
  } // end of patchPickUpDetailForm

  savePickUp() {
    console.log(`savePickUp, isNew:${this.isNew}`);
    if(!this.isNew) {
      this.updatePickUp();
    } else {
      this.createPickUp();
    }
  } // end of savePickUp

  updatePickUp() {
    this.isSavingPickUp = true;
    this.createPickUpUpdatePayload();
    console.log(`updatePickUp, pickUpUpdateData:${this.pickUpUpdateData}`);
    this.petService.updatePickUp(this.selectedPickUp.id, this.pickUpUpdateData).subscribe({
      next: (response) => {
        this.isSavingPickUp = false;
        console.log(`updatePickUp, response: ${JSON.stringify(response)}`);
        this.hideModal(true);
        this.router.navigate(['pick-up']);
      },
      error: (error) => {
        this.isSavingPickUp = false;
        console.error(`updatePickUp, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingPickUp = false;
  } // end of updatePickUp

  createPickUp() {
    this.isSavingPickUp = true;
    this.createPickUpUpdatePayload();
    console.log(`createPickUp, pickUp data:${JSON.stringify(this.pickUpUpdateData)}`);
    this.petService.createPickUp(this.pickUpUpdateData).subscribe({
      next: (response) => {
        this.isSavingPickUp = false;
        console.log(`createPickUp, response: ${JSON.stringify(response)}`);
        this.hideModal(true)
      },
      error: (error) => {
        this.isSavingPickUp = false;
        console.error(`createPickUp, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingPickUp = false;
  } // end of createPickUp

  createPickUpUpdatePayload() {
    const formValues = this.pickUpDetailForm.value;
    const date_time = new Date(`${formValues.date} ${formValues.time}`);
    console.log(`createPickUpUpdatePayload, date_time: ${date_time}`);
    const date_time_utc = convertToLocalTimeToUTC(`${formValues.date} ${formValues.time}`);
    console.log(`createPickUpUpdatePayload, date_time_utc: ${date_time_utc}`);

    this.pickUpUpdateData.append('first_name', formValues.firstName);
    this.pickUpUpdateData.append('last_name', formValues.lastName);
    this.pickUpUpdateData.append('phone', formValues.phone);
    this.pickUpUpdateData.append('address', formValues.address);
    this.pickUpUpdateData.append('date_time', date_time_utc);
    // this.pickUpUpdateData.append('date_time', `${formValues.date} ${formValues.time}`);
  }  // end of createPickUpUpdatePayload

  closeModal() {
    this.hideModal(false);
  } // end of closeModal

  hideModal(result: boolean) {
    this.onClose.next(result);
    this.bsModalRef.hide();
  } // end of hideModal
}
